import { render, staticRenderFns } from "./BuilderWidget.vue?vue&type=template&id=0ac4a6b4&scoped=true&"
import script from "./BuilderWidget.vue?vue&type=script&lang=js&"
export * from "./BuilderWidget.vue?vue&type=script&lang=js&"
import style0 from "./BuilderWidget.vue?vue&type=style&index=0&id=0ac4a6b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac4a6b4",
  null
  
)

export default component.exports